import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { AUTH_API } from "../config/api";
import {
  Container,
  Header,
  SpaceBetween,
  Alert,
  Box,
  Spinner,
  Button,
} from "@cloudscape-design/components";
import "./SignIn.css";

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Lien de vérification invalide : aucun token fourni.");
      return;
    }

    const verify = async () => {
      try {
        const response = await fetch(`${AUTH_API.verifyEmail}?token=${encodeURIComponent(token)}`);
        const data = await response.json();
        if (response.ok) {
          setStatus("success");
          setMessage(data.message || "Email vérifié avec succès.");
        } else {
          setStatus("error");
          setMessage(data.error || "La vérification a échoué. Veuillez réessayer.");
        }
      } catch (error) {
        console.error("Email verification error:", error);
        setStatus("error");
        setMessage("Erreur de connexion au serveur. Veuillez réessayer plus tard.");
      }
    };

    verify();
  }, [searchParams]);

  return (
    <div className="signin-page">
      <div className="signin-bg-image" aria-hidden="true">
        <img src={`${process.env.PUBLIC_URL}/backgroundhero.png`} alt="" />
      </div>
      <div className="signin-overlay" aria-hidden="true" />

      <div className="signin-header">
        <img src="/logoadexcloud.png" alt="Adexgénie" className="signin-logo" />
        <div className="signin-title">Adexgénie</div>
      </div>

      <div className="signin-form-overlay">
        <div className="signin-form-card">
          <Container
            header={
              <Header variant="h1">
                Vérification de l'email
              </Header>
            }
          >
            <SpaceBetween size="l" direction="vertical">
              {status === "loading" && (
                <Box textAlign="center" padding={{ vertical: "l" }}>
                  <Spinner size="large" />
                  <Box padding={{ top: "m" }}>Vérification en cours...</Box>
                </Box>
              )}
              {status === "success" && (
                <>
                  <Alert type="success">{message}</Alert>
                  <Box textAlign="center">
                    <Button variant="primary" href="/signin">
                      Aller à la connexion
                    </Button>
                  </Box>
                </>
              )}
              {status === "error" && (
                <>
                  <Alert type="error">{message}</Alert>
                  <Box textAlign="center">
                    <Link to="/signin">Retour à la connexion</Link>
                  </Box>
                </>
              )}
            </SpaceBetween>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
